export default __webpack_public_path__ + "static/media/PTAR_CLI.17d22d2c.png";